import { render, staticRenderFns } from "./ClientAveragePaymentDurationInvoiceList.vue?vue&type=template&id=964a9df6&"
import script from "./ClientAveragePaymentDurationInvoiceList.vue?vue&type=script&lang=js&"
export * from "./ClientAveragePaymentDurationInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./ClientAveragePaymentDurationInvoiceList.vue?vue&type=style&index=0&id=964a9df6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports